export const FETCH_FILMS_GENRES_SUCCES = 'FETCH_FILMS_GENRES_SUCCES';
export const FETCH_FILMS_GENRES_FAIL = 'FETCH_FILMS_GENRES_FAIL';
export const FETCH_FILMS_REFRESH = 'FETCH_FILMS_REFRESH';

export const FETCH_FILMS_SEARCH_SUCCES = 'FETCH_FILMS_SEARCH_SUCCES';
export const FETCH_FILMS_SEARCH_FAIL = 'FETCH_FILMS_SEARCH_FAIL';
export const FETCH_FILMS_SEARCH_REFRESH = 'FETCH_FILMS_SEARCH_REFRESH';

export const FETCH_FILMS_DETAILS_SUCCES = 'FETCH_FILMS_DETAILS_SUCCES';
export const FETCH_FILMS_DETAILS_FAIL = 'FETCH_FILMS_DETAILS_FAIL';

export const FAVORITES_FILMS_IN_CACHE = 'FAVORITES_FILMS_IN_CACHE';
